import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnpublishIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Unpublish",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M19.6 17.12c-.57 0-1.03.46-1.03 1.03v8.09l-2.05-2.05c-.43-.43-1.12-.43-1.55 0s-.43 1.12 0 1.55l4 3.94q.15.15.36.24c.26.11.56.11.82 0 .12-.06.24-.14.33-.25l3.94-3.93c.21-.2.33-.48.33-.77 0-.3-.12-.58-.34-.79-.2-.21-.48-.33-.77-.32-.3 0-.58.12-.78.34l-2.05 2.05v-8.06c.03-.57-.4-1.05-.97-1.08-.08 0-.16 0-.23.01ZM10.09 2C8.21 2 6.68 3.52 6.68 5.41V20.1c0 1.88 1.52 3.41 3.41 3.41h2.84c.53.01.96-.4.98-.93v-.1c.02-.5-.37-.93-.87-.95H10.1c-.81 0-1.46-.66-1.46-1.47V5.41c0-.81.65-1.47 1.46-1.48s11.84 0 11.84 0c.81 0 1.46.66 1.46 1.47v13.01c.1.46.5.79.97.8.47.03.89-.3.96-.77V5.41c0-1.88-1.52-3.4-3.4-3.41zm6.05 13.09h-5.13a.72.72 0 0 0-.8.63c-.05.39.23.75.63.8h5.3c.39.05.75-.23.8-.63a.72.72 0 0 0-.63-.8zm4.87-4.29H11c-.4 0-.72.32-.72.72s.32.72.72.72h10.01c.4 0 .72-.32.72-.72s-.32-.72-.72-.72m0-4.2H11a.72.72 0 0 0-.8.63c-.05.39.23.75.63.8h10.18c.39.05.75-.23.8-.63s-.23-.75-.63-.8z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.32 30.57H8.29c-1.89 0-3.43-1.54-3.43-3.43V6.57c0-1.89 1.54-3.43 3.43-3.43h9.14a1.14 1.14 0 1 1 0 2.28H8.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h16.04c.63 0 1.14-.51 1.14-1.14V15.7a1.14 1.14 0 1 1 2.28 0v11.43c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.04 14.57c-.63 0-1.14-.51-1.14-1.14V2a1.14 1.14 0 1 1 2.28 0v11.43c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.04 14.57c-.29 0-.58-.11-.81-.33l-4.57-4.57a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.76 3.76 3.76-3.76a1.15 1.15 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-4.57 4.57c-.22.22-.52.33-.81.33M22 26H10.57a1.14 1.14 0 1 1 0-2.28H22A1.14 1.14 0 1 1 22 26M22 21.43H10.57a1.14 1.14 0 1 1 0-2.28H22a1.14 1.14 0 1 1 0 2.28M17.43 16.86h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
UnpublishIcon.displayName = 'UnpublishIcon';